import { useState } from "react";
import { newsFeed, categories } from "@/mocks/homeData";

export default function Latest() {
  const allCat = [{ id: "all", name: "全部瓜闻" }, ...categories];
  const [active, setActive] = useState("all");
  const list = active === "all" ? newsFeed : newsFeed.filter((n) => n.cat === active);

  return (
    <section id="latest" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">最新瓜闻 · LATEST</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">最新瓜闻速递</h2>
          </div>
          <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="按赛道筛选瓜闻">
            {allCat.map((c) => (
              <button
                key={c.id}
                type="button"
                role="tab"
                aria-selected={active === c.id}
                onClick={() => setActive(c.id)}
                className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  active === c.id
                    ? "bg-primary-600 font-medium text-background-50"
                    : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:text-primary-700"
                }`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((n) => (
            <article
              key={n.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={n.img}
                  alt={n.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-800 backdrop-blur-sm">
                  <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                  {n.cat}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-foreground-950">
                  <i className="ri-flashlight-fill" aria-hidden="true"></i>{n.trend}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="line-clamp-2 font-heading text-base font-bold leading-7 text-foreground-900 transition-colors group-hover:text-primary-800 md:text-lg">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-6 text-foreground-600">{n.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-time-line" aria-hidden="true"></i>{n.time}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-eye-line" aria-hidden="true"></i>{n.reads} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 rounded-2xl border border-dashed border-background-300 bg-background-50 p-8 text-center text-sm text-foreground-500">
            该赛道今日暂无更新，看看「全部瓜闻」吧。
          </p>
        )}
      </div>
    </section>
  );
}